/**
 * NumberRangeInput Component
 *
 * Number range input for BETWEEN operator with numeric fields.
 * Two InputNumber fields with "to" label between them.
 * Returns [min, max] tuple and validates min <= max.
 */

import { InputNumber, Space, Typography } from 'antd'

const { Text } = Typography

interface NumberRangeInputProps {
  value?: number
  value2?: number
  onChange: (value: number | null, value2: number | null) => void
  placeholders?: [string, string]
}

export function NumberRangeInput({
  value,
  value2,
  onChange,
  placeholders = ['Min', 'Max'],
}: NumberRangeInputProps) {
  // Handle min value change
  const handleMinChange = (newValue: number | null) => {
    onChange(newValue, value2 ?? null)
  }

  // Handle max value change
  const handleMaxChange = (newValue: number | null) => {
    onChange(value ?? null, newValue)
  }

  // Validation: Check if min > max
  const hasValidationError =
    value !== null &&
    value !== undefined &&
    value2 !== null &&
    value2 !== undefined &&
    value > value2

  return (
    <div style={{ width: '100%' }}>
      <Space.Compact style={{ width: '100%' }}>
        <InputNumber
          value={value ?? null}
          onChange={handleMinChange}
          placeholder={placeholders[0]}
          style={{ width: '45%' }}
          controls={false}
          precision={2}
          status={hasValidationError ? 'error' : undefined}
        />
        <Text
          type="secondary"
          style={{
            width: '10%',
            textAlign: 'center',
            lineHeight: '32px',
            fontSize: '12px',
          }}
        >
          to
        </Text>
        <InputNumber
          value={value2 ?? null}
          onChange={handleMaxChange}
          placeholder={placeholders[1]}
          style={{ width: '45%' }}
          controls={false}
          precision={2}
          status={hasValidationError ? 'error' : undefined}
        />
      </Space.Compact>
      {hasValidationError && (
        <Text type="danger" style={{ fontSize: 12, marginTop: 4, display: 'block' }}>
          Min must be less than or equal to Max
        </Text>
      )}
    </div>
  )
}
